import {Controller} from "@hotwired/stimulus";
import {Turbo} from "@hotwired/turbo-rails";
import {get} from "@rails/request.js";

export default class ScheduleFormController extends Controller {
  static targets = [
    // Days
    'multipleContainer',
    'multipleCheckboxContainer',

    'fields',

    // Buttons
    'multipleUpdate',
    'multipleUpdateOptions',
  ]

  connect() {
    console.log("Schedule Form", this.element);

    this.onMultipleChanged()
  }

  onSubmit(event) {
    console.debug("SUBMITING");

    const formData = new FormData(this.element);
    for (const [key, value] of formData.entries()) {
      console.debug(key, value);
    }
  }

  showMultipleOptions() {
    this.multipleUpdateTarget.classList.add('d-none')
    this.fieldsTarget.classList.add('d-none')
    this.multipleUpdateOptionsTarget.classList.remove('d-none')

    const modalContent = this.element.closest(".modal-content");
    if (modalContent == null) {
      return;
    }

    const modalTitle = modalContent.querySelector(".modal-title");
    if (modalTitle == null) {
      return;
    }

    modalTitle.textContent = "Editar Clase de Calendario";
  }

  onMultipleChanged() {
    if (this.multipleCheckbox == null) {
      return
    }

    console.log(this.multipleCheckbox);
    this.multipleContainerTargets.forEach((target) => {
      if (this.multipleCheckbox.checked) {
        target.classList.remove('d-none');
        target.classList.add('d-flex');
      } else {
        target.classList.remove('d-flex');
        target.classList.add('d-none');
      }
    });
  }

  onLessonChanged() {
    const option = this.lessonSelect.selectedOptions[0];
    console.log(this.lessonSelect.value, option.dataset.virtual);
  }

  get multipleCheckbox() {
    const multiple =  this.element['schedule[multiple]']

    if (multiple == null) {
      return;
    }

    // Rails uses 2 checkboxes to handle empty checkboxes
    return multiple[1];
  }

  get lessonSelect() {
    return this.element['schedule[lesson_id]'];
  }

  // async checkFormResponse(event) {
  //   const {success, fetchResponse, formSubmission} = event.detail;
  //
  //   if (formSubmission.formElement.id !== this.element.id) {
  //     console.warn("Schedule form skipped", formSubmission);
  //     return;
  //   }
  //
  //   console.log("SCHEDULE FORM", success, fetchResponse, event);
  //
  //   if (success) {
  //     dispatchEvent(new CustomEvent('schedule-form:schedule-saved'));
  //   } else {
  //     const response = await fetchResponse.response.json();
  //   }
  // }
  // reloadLessons(event) {
  //   const gymId = event.detail.id;
  //
  //   console.log('=> reload lessons');
  //   // TODO reload lessons from backend
  //
  //   this.lessonSelect.innerHTML = '';
  //
  //   this.loadLessons(gymId).then((lessons) => {
  //     this.fillLessonSelect(lessons);
  //   });
  // }

  // updateGymAndTimezone(event) {
  //   const timezone = event.detail.city.timezone_name;
  //   const gymId = event.detail.id;
  //   this.timeZoneField.value = timezone;
  //   this.gymIdField.value = gymId;
  // }

  // fillLessonSelect(lessons) {
  //   const lessonsHTML = lessons.map((lesson) => {
  //     // console.log("LESSON VIRTUAL: ", lesson);
  //     return `<option data-virtual="${this.isLessonVirtual(lesson)}" value="${lesson.id}">${lesson.name}</option>`;
  //   }).join("\n");
  //
  //   this.lessonSelect.innerHTML = '<option value=""></option>' + lessonsHTML;
  // }

  // isLessonVirtual(lesson) {
  //   for (const activity of lesson.activities) {
  //     if (activity.virtual) {
  //       return true;
  //     }
  //   }
  //
  //   return false;
  // }

  // new(event) {
  //   console.log("EVENT", event);
  //   this.element.reset();
  //   this.element.classList.remove("was-validated");
  //
  //   this.setMode('new');
  //
  //   const dateTime = DateTime.fromISO(event.detail.dateStr);
  //
  //   this.startDateField.value = dateTime.toISODate();
  //   this.lessonTimeField.value = dateTime.toISOTime({
  //     suppressMilliseconds: true,
  //     suppressSeconds: true,
  //     includeOffset: false
  //   });

    // console.log(dateTime.toISOTime(), dateTime.toISOTime({
    //   suppressMilliseconds: true,
    //   suppressSeconds: true,
    //   includeOffset: false
    // }))
  // }

  // edit(event) {
  //   console.log("EVENT", event.detail);
  //   this.element.reset();
  //   this.element.classList.remove("was-validated");
  //
  //   this.fillForm(event.detail);
  //
  //   this.setMode('edit');
  // }
  //
  // setMode(mode) {
  //   this.mode = mode;
  //
  //   if (mode === 'edit') {
  //     this.setEditMode();
  //   } else {
  //     this.setNewMode();
  //   }
  // }

  // setEditMode() {
  //   this.multipleCheckboxContainerTarget.classList.add('d-none');
  // }
  //
  // setNewMode() {
  //   this.multipleCheckboxContainerTarget.classList.remove('d-none');
  // }

  // fillForm(schedule) {
  //   const lessonTime = DateTime.fromISO(schedule.lesson_time);
  //
  //   this.startDateField.value = lessonTime.toISODate();
  //   this.lessonTimeField.value = lessonTime.toISOTime({
  //     suppressMilliseconds: true,
  //     suppressSeconds: true,
  //     includeOffset: false
  //   });
  //
  //   this.idField.value = schedule.id;
  //   this.lessonField.value = schedule.lesson_id;
  //   this.lessonAvailabilityField.value = schedule.lesson_availability;
  //   this.lengthField.value = schedule.length;
  //   this.instructorNameField.value = schedule.instructor.name;
  // }
  //
  // get idField() {
  //   return this.element['schedule[id]'];
  // }
  //
  // get gymIdField() {
  //   return this.element['schedule[gym_id]'];
  // }
  //
  // get timeZoneField() {
  //   return this.element['schedule[time_zone]'];
  // }
  //
  // get startDateField() {
  //   return this.element['schedule[start_date]'];
  // }
  //
  // get lessonTimeField() {
  //   return this.element['schedule[lesson_time]'];
  // }
  //
  // get lengthField() {
  //   return this.element['schedule[length]'];
  // }
  //
  // get lessonField() {
  //   return this.element['schedule[lesson_id]'];
  // }
  //
  // get lessonAvailabilityField() {
  //   return this.element['schedule[lesson_availability]'];
  // }
  //
  // get instructorNameField() {
  //   return this.element['schedule[instructor_name]'];
  // }
  //
  // get joinInfoField() {
  //   return this.element['schedule[join_info]'];
  // }

  disconnect() {
  }
}
